export default function ReasonsToEmpty() {
  const reasons = [
    {
      icon: 'ri-home-smile-line',
      title: 'Mudanza o venta de la propiedad',
      description: 'Si has decidido mudarte o vender tu vivienda, necesitas despejar el espacio rápidamente. Te ayudamos a deshacerte de muebles, ropa, libros y enseres que ya no necesitas, ahorrándote tiempo y dinero.'
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Fallecimiento de un familiar',
      description: 'Cuando un ser querido fallece, los familiares deben hacerse cargo de la vivienda y gestionar sus pertenencias. Nuestro servicio te ayuda a aliviar esta carga emocional en un momento difícil, tratando todo con el máximo respeto.'
    },
    {
      icon: 'ri-delete-bin-line',
      title: 'Acumulación de objetos y limpieza extrema',
      description: 'En casos de acumulación excesiva de objetos o síndrome de Diógenes, se hace imprescindible un vaciado completo y una limpieza profunda. Contamos con experiencia en estos casos delicados.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Reformas y renovaciones',
      description: 'Si planeas hacer una reforma en casa, necesitarás despejar el espacio antes de comenzar los trabajos. Es el momento perfecto para deshacerte de todo aquello que no necesitas y empezar de cero.'
    },
    {
      icon: 'ri-building-line',
      title: 'Desalojo o cambio de inquilinos',
      description: 'Propietarios que necesitan recuperar su piso tras un desalojo o cuando los inquilinos dejan objetos abandonados. Nos encargamos de dejarlo listo para los nuevos ocupantes.'
    },
    {
      icon: 'ri-time-line',
      title: 'Urgencias y plazos ajustados',
      description: 'Situaciones que requieren un vaciado rápido por entrega de llaves, venta urgente o cualquier otro motivo con fecha límite. Ofrecemos servicio express en 24-48 horas.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-teal-600 font-semibold text-sm sm:text-base uppercase tracking-wide">
            Situaciones Comunes
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 px-2">
            Razones para vaciar un piso en Barcelona
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Hay muchas situaciones en las que necesitas vaciar un piso. Conoce los casos más frecuentes en los que nuestros clientes solicitan nuestro servicio profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-6 sm:p-8 hover:shadow-lg transition-all duration-300 border border-gray-200 hover:border-teal-300"
            >
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-5">
                <i className={`${reason.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 sm:mt-16 bg-gradient-to-r from-teal-600 to-cyan-600 rounded-2xl p-6 sm:p-8 md:p-10 text-white text-center">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4">
            Sea cual sea tu situación, tenemos la solución
          </h3>
          <p className="text-base sm:text-lg mb-6 max-w-3xl mx-auto opacity-95">
            Cada caso es único y requiere un enfoque personalizado. Cuéntanos tu situación y te ofreceremos la mejor solución adaptada a tus necesidades específicas.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href="tel:629501941"
              className="inline-flex items-center gap-2 bg-white text-teal-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg sm:text-xl"></i>
              Llámanos ahora
            </a>
            <button
              onClick={() => {
                const element = document.getElementById('contacto');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 bg-teal-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-800 transition-colors border-2 border-white/30 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg sm:text-xl"></i>
              Solicita presupuesto
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
